import { render, staticRenderFns } from "./FootBlock.vue?vue&type=template&id=9fe0914e&"
import script from "./FootBlock.vue?vue&type=script&lang=js&"
export * from "./FootBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CA5\\PhpstormProjects\\te-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9fe0914e', component.options)
    } else {
      api.reload('9fe0914e', component.options)
    }
    module.hot.accept("./FootBlock.vue?vue&type=template&id=9fe0914e&", function () {
      api.rerender('9fe0914e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Partials/FootBlock.vue"
export default component.exports